import $ from 'jquery';

export default class Video {
    constructor() {
        if($('.js-video__poster').length) {
            $('body').on('click', '.js-video__poster', function () {
                const $video = $(this).closest('.js-video').find('iframe');

                $(this).fadeOut();

                // Check for querystring existence
                const symbol = $video[0].src.indexOf("?") > -1 ? "&" : "?";

                // Modify source to autoplay and start video
                $video[0].src += symbol + "autoplay=1";
            });
        };
    };
};
